// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
export const HPE_MY_ACCOUNT = 'HPE MyAccount'
export const USER_SCHEMAS = Object.freeze({
  EXTENSIONS: 'urn:ietf:params:scim:schemas:extensions:hpe-greenlake:2.0:User'
})
export const SUBJECT_SOURCE = Object.freeze({
  LOCAL: 'Local',
  SSO: 'SSO',
  EXTERNAL: 'External',
  SCIM: 'SCIM'
})
